import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getMonthsAndYears,
  getEmployeeFiltred,
  getSalaireEmp,
  getEmployeeSalaryWitoutPresenceAndUpdateHisPrime,
  getInfoAndUpdatePrimeForManyEmployees,
} from "../../../../services/RHService/PaiementService";
import {
  getPrimeByUser,
  getPrimes,
} from "../../../../services/RHService/PrimeService";
import jsPDF from "jspdf";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const PaimentwithSelectionComp = ({ selectedUsers, isVisible }) => {
  const [formDataForSelection, setFormDataForSelection] = useState({});
  const [pageLoaded, setPageLoaded] = useState(false);

  const handleInputChangeForSelection = (event) => {
    const { name, value } = event.target;
    setFormDataForSelection({ ...formDataForSelection, [name]: value });
  };
  const [primes, setPrimes] = useState([]);
  useEffect(() => {
    const fetchDataPrimes = async () => {
      try {
        const response = await getPrimes(getCurrentUserId());

        if (response.data.success) {
          setPrimes(response.data.success);
        } else {
          setPrimes([]);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchDataPrimes();
  }, []);

  const [showModalForPrimes, setShowModalModalForPrimes] = useState(false);

  const handleCloseModalForPrimes = () => setShowModalModalForPrimes(false);
  const handleShowModalForPrimes = () => {
    setShowModalModalForPrimes(true);
  };
  const [selectedPrimes, setSelectedPrimes] = useState([]);

  const handlePrimeAmountChangeForSelectedUsers = (event, index) => {
    const { value } = event.target;

    // Update primes state
    const updatedPrime = primes.map((c, i) =>
      i === index ? { ...c, primeAmount: value || "" } : c
    );

    // Update inputList
    const updatedInputList = updatedPrime
      .filter((c) => c.primeAmount !== "")
      .map((c) => ({ idPrime: c.id, primeAmount: c.primeAmount }));

    // Include additional inputs
    const additionalInputs = updatedPrime.filter((c) => c.id === "inputCheck");
    additionalInputs.forEach((input) => {
      updatedInputList.push({ idPrime: input.id, primeAmount: "" });
    });

    setSelectedPrimes(updatedInputList);
  };

  // input: is affected
  const handleCheckboxChange = (index) => {
    const updatedPrime = primes.map((c, i) => (i === index ? { ...c } : c));

    // Update inputList
    const updatedInputList = updatedPrime
      .filter((c) => c.primeAmount !== "")
      .map((c) => ({ idPrime: c.id, primeAmount: c.primeAmount }));

    // Include additional inputs
    if (updatedPrime[index].id === "inputCheck") {
      updatedInputList.push({ idPrime: "inputCheck", primeAmount: "" });
    }

    setSelectedPrimes(updatedInputList);
  };
  const [heureSupp, setHeureSupp] = useState({ heureSupp: "" });
  const handleSuppHeureChange = (event) => {
    const { value } = event.target;
    setHeureSupp({ heureSupp: value });
  };

  const [userSalarySelection, setUserSalarySelection] = useState([]);
  const handleGenerateSalarySheetSelection = async (event) => {
    event.preventDefault();

    try {
      console.log(selectedPrimes);
      console.log(selectedUsers);

      if (
        selectedUsers &&
        formDataForSelection.dateDeb &&
        formDataForSelection.dateFin
      ) {
        const response = await getInfoAndUpdatePrimeForManyEmployees(
          heureSupp.heureSupp,
          formDataForSelection.dateDeb,
          formDataForSelection.dateFin,
          selectedUsers,
          selectedPrimes
        );
        console.log(response);

        setUserSalarySelection(response);
        setPageLoaded(true);
      } else {
        toastr.error("Saisir date début et date fin");
      }
    } catch (error) {
      toastr.error("Erreur lors de la vérification.");
    }
  };

  useEffect(() => {
    if (pageLoaded && userSalarySelection.length !== 0) {
      //   const year = formData.year;
      const fileName = `fiche_des_Salaires.xlsx`; // Include month name in the file name

      const excelDatas = userSalarySelection.map((user) => ({
        Personnels: {
          v: user.firstName + " " + user.lastName,
        },
        Rib: user.rib,
        "Numéro CNSS": user.numCnss || 0,
        "Heures de travail": user.heureDeTravail,
        "Heures supplimentaire": user.suppHours || 0,
        "Montant heures supplimentaire": user.suppHours || 0,
        "Salaire de base ": user.salaireDeBase,
        "Totale Prime ": user.totprimes,
        "Salaire Brut ": user.salaireBrut,
        "Cotisation Cnss ": user.cnssContribution,
        "Salaire imposable ": user.salaireImposable,
        "Impot sur le revenue": user.taxIR,
        "Salaire Aprés impot": user.salaryAfterTax,

        "Cotisation Css ": user.cssContribution,
        "Salaire Net": user.salaryWithoutAdvantage,
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(excelDatas);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Feuille de salaire");
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const excelData = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      saveAs(excelData, fileName);
    }
  }, [userSalarySelection]);

  return (
    <>
      <Modal
        show={showModalForPrimes}
        onHide={handleCloseModalForPrimes}
        size="l"
      >
        <Modal.Header closeButton>
          <Modal.Title>Génerer fiche de paie selective</Modal.Title>
        </Modal.Header>
        <Modal.Body className="show-grid">
          <Form onSubmit={handleGenerateSalarySheetSelection}>
            <div>
              {primes.length !== 0 && (
                <div>
                  {primes.map((c, index) => (
                    <div key={c.id} className="row">
                      <div className="col-md-6 icheck-dark d-inline mx-1">
                        <input
                          type="checkbox"
                          id={c.nomPrime}
                          value={c.id}
                          name="id"
                          onChange={() => handleCheckboxChange(index)}
                        />
                        <label htmlFor={c.nomPrime}>{c.nomPrime}</label>
                      </div>
                      <div className="col-md mx-1 mt-1">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(event) =>
                            handlePrimeAmountChangeForSelectedUsers(
                              event,
                              index
                            )
                          }
                          name="primeAmount"
                          placeholder="Montant de Prime"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="col-md mx-1 mt-1">
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => handleSuppHeureChange(event)}
                  name="heureSupp"
                  value={heureSupp.heureSupp || ""}
                  placeholder="Tapez les heures Supplimentaires"
                />
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleGenerateSalarySheetSelection} variant="dark">
            Générer
          </Button>
        </Modal.Footer>
      </Modal>
      {selectedUsers.length > 0 && isVisible && (
        // <form onSubmit={handleGenerateSalarySheetSelection}>
        <div className="row">
          <div className="col-md-6 mx-3 mt-2">
            <input
              className="form-control input-date"
              style={{ paddingLeft: "6px" }}
              type="date"
              min="1900-01-01"
              max="2500-12-31"
              id="month"
              name="dateDeb"
              onChange={handleInputChangeForSelection}
              value={formDataForSelection.dateDeb || ""}
            />
          </div>

          <div className="col-md-6 mx-3 mt-2">
            <input
              className="form-control input-date"
              style={{ paddingLeft: "6px" }}
              type="date"
              min="1900-01-01"
              max="2500-12-31"
              id="year"
              name="dateFin"
              onChange={handleInputChangeForSelection}
              value={formDataForSelection.dateFin || ""}
            />
          </div>

          <div className="col-md text-right">
            <button
              onClick={() => {
                handleShowModalForPrimes(selectedUsers);
              }}
              className="generate right mx-2 mt-1"
              type="submit"
            >
              Générer fiches de paie
            </button>
          </div>
        </div>
        // </form>
      )}
    </>
  );
};
export default PaimentwithSelectionComp;
